import { render, staticRenderFns } from "./archived-tasks.vue?vue&type=template&id=3bf4e082&scoped=true"
import script from "./archived-tasks.vue?vue&type=script&lang=js"
export * from "./archived-tasks.vue?vue&type=script&lang=js"
import style0 from "./archived-tasks.vue?vue&type=style&index=0&id=3bf4e082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf4e082",
  null
  
)

export default component.exports